import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetSingleAppointmentData = async (appointmentId) => {
  /**
   * input: Appointment ID
   * output: Appointment object
   * description: fetches single Appointment
   */

  try {
    let appointmentsCollection = await collection(db, "appointments");
    let appointmentDocument = await doc(appointmentsCollection, appointmentId);
    const appointmentsSnapshot = await getDoc(
      appointmentDocument,
      where("bid", "==", getLocalStorageItem("bid"))
    );

    let appointment = {
      ...appointmentsSnapshot.data(),
      id: appointmentsSnapshot.id,
    };
    return appointment;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleAppointmentData;
